<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="c-form-item c-form-item-date-range-picker">
    <el-time-picker
      is-range
      v-model="model[prop]"
      v-bind="innerAttrs"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      placeholder="选择时间范围"
    ></el-time-picker>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { inject } from '@zto/zpage'
import { C_FORM_KEY } from '../../../consts'
import { useFormItem } from '../util'

const cForm = inject<any>(C_FORM_KEY, null)

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    disabled?: boolean
  }>(),
  {
    disabled: false
  }
)

const { innerAttrs } = useFormItem(props)

// 值发生变化后，调用form的校验，解决值发生变化后没校验的问题
function handleChange() {
  if (cForm) {
    cForm.validateFields([props.prop, props.toProp])
  }
}
</script>
